import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingFallback: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        gap: 2,
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="body1" color="text.secondary">
        Загрузка...
      </Typography>
    </Box>
  );
};

export default LoadingFallback;
